var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 75,
    viewBox: "0 0 1440 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1457 0.134766L0.036377 2.16946V173.852H1457V0.134766Z",
    fill: "url(#paint0_linear_2_383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.036377 2.16946V60.3889L1457 71.1958V0.134766L0.036377 2.16946Z",
    fill: "url(#paint1_linear_2_383)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1457 0.134766L0.036377 2.16946V14.2913L1457 3.65709V0.134766Z",
    fill: "url(#paint2_linear_2_383)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0364241 65.8789L1404.8 82.9723H902.99L1457 94.835V167.134L54.6726 151.701L499.046 146.662L0 139.301L0.0364241 65.8789Z",
    fill: "#EFFF8E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1457 7.21777L72.8846 17.8904H482.656L0.0364241 23.1691L0 51.4822L1334.98 44.2839L340.456 62.9129L937.957 65.8786L1457 71.1957V7.21777Z",
    fill: "#EFFF8E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1457 71.1958L174.799 61.6846L596.19 68.2782L1457 83.6344V71.1958Z",
    fill: "#D9D5E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_383",
    x1: 728.518,
    y1: 173.852,
    x2: 728.518,
    y2: 0.134766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A8100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_383",
    x1: 728.518,
    y1: 71.1958,
    x2: 728.518,
    y2: 0.134766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_383",
    x1: 728.518,
    y1: 14.2913,
    x2: 728.518,
    y2: 0.134766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90B400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CD00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLogin);
export default __webpack_public_path__ + "static/media/bottomLogin.e14c39fa10e22a70ff5b8fd626b3a616.svg";
export { ForwardRef as ReactComponent };